import React, { useState, useRef, useEffect } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import { 
    Flex, Center, Box, Button, ButtonGroup, Text, Icon, HStack, VStack, Spacer, Divider, 
    Select, Badge, Link, CircularProgress, CircularProgressLabel, useToast
} from '@chakra-ui/react';
import { MdThumbUp, MdCheckCircle, MdCancel } from 'react-icons/md';
import { FormattedDate, FormattedNumber } from 'react-intl';

import axios from 'axios';
import {faker} from '@faker-js/faker';
import { sum } from 'lodash';
import { withNamespaces } from 'react-i18next';

import { setNavTab } from '../../redux/actions';
import { ACTIVE_SCHEDULE_SUCCESSFUL_TAB } from '../../redux/constants';
import { 
    API_SUB_URL_SCHEDULE_MEDICAL, API_SUB_URL_PATIENT, PROCESSING_STATUS, PENDING_STATUS,
    PATIENT_INFORMATION_MAX_AGE, MAKE_DOCTOR_APPOINTMENT, ERROR_CODES 
} from '../../constants';
import { displayConfirmAlert, displayConfirmChoiceAlert } from '../utils';

import Header from '../Home/Header';
import Navbar from '../Home/Navbar';
import NoDataPage from '../../components/NoData';
import NoEventPage from '../../components/NoEvent';

function ViewPatientTicket({ setNavTab, t }) {
    const [ cookies, setCookie, removeCookie ] = useCookies(["makeDoctorAppointmentDatas", "selectedClinic"]);
    const [ isSubmitting, setIsSubmitting ] = useState(false);
    const [ isProcessPaymentOnline, setIsProcessPaymentOnline ] = useState(false);
    const mounted = useRef();
    const navigate = useNavigate();
    const toast = useToast();

    useEffect(() => {
        if(!mounted.current) {
            if(!cookies.selectedClinic?.data?.id) {
                displayConfirmAlert("Bạn vui lòng chọn phòng khám trước khi tiếp tục!", () => {
                    navigate("/");
                });
            } else {
                if(cookies["makeDoctorAppointmentDatas"]?.data?.patientDetail && !cookies["makeDoctorAppointmentDatas"]?.data?.scheduleNumber) {
                    setCookie("makeDoctorAppointmentDatas", 
                        { 
                            data: {
                                ...cookies["makeDoctorAppointmentDatas"]?.data,
                                scheduleNumber: faker.string.alphanumeric(8).toUpperCase()
                            } 
                        }, 
                        { path: '/', maxAge: PATIENT_INFORMATION_MAX_AGE }
                    );
                }
                setNavTab(ACTIVE_SCHEDULE_SUCCESSFUL_TAB);

                if(cookies.selectedClinic?.data?.systemSettingDetail?.payment_methods) {
                    const payment_methods = cookies.selectedClinic?.data?.systemSettingDetail?.payment_methods;
                    setIsProcessPaymentOnline(
                        payment_methods?.isPaymentOnline && payment_methods?.client_id?.length > 0 && 
                        payment_methods?.api_key?.length > 0 && TOTAL_SERVICE_PRICE >= 2000
                    );
                }
            }

            mounted.current = true;
        }
    });

    const handleSave = async() => {
        const { 
            company_id, scheduleNumber, scheduleDate, selectedMedicalTime, reasonNeedDoctor, 
            patientDetail, departmentDetail, doctorDetail, servicePriceDetail,
        } = cookies.makeDoctorAppointmentDatas?.data || {};

        setIsSubmitting(true);

        try
        {
            let patient_id;

            if(cookies.makeDoctorAppointmentDatas?.data?.isNewRegister) {
                const createNewPatientRes = await axios.post(`${process.env.REACT_APP_API_ENDPOINT_URL}/${API_SUB_URL_PATIENT}`, {
                    company_id: cookies.selectedClinic?.data?.id,
                    ...patientDetail
                }, {
                    auth: {
                        username: process.env.REACT_APP_BASIC_AUTH_USERNAME,
                        password: process.env.REACT_APP_BASIC_AUTH_PASSWORD
                    }
                });

                patient_id = createNewPatientRes.data?.data?.id;
            } else {
                patient_id = patientDetail.id;
            }

            const createNewScheduleMedicalRes = await axios.post(`${process.env.REACT_APP_API_ENDPOINT_URL}${API_SUB_URL_SCHEDULE_MEDICAL}`, {
                company_id,
                patient_id,
                schedule_number: scheduleNumber,
                department_id: departmentDetail.id,
                doctor_id: doctorDetail.id,
                day_schedule: scheduleDate,
                time_schedule: selectedMedicalTime,
                description: reasonNeedDoctor,
                service_prices: servicePriceDetail,
                status: PROCESSING_STATUS
            }, {
                auth: {
                    username: process.env.REACT_APP_BASIC_AUTH_USERNAME,
                    password: process.env.REACT_APP_BASIC_AUTH_PASSWORD
                }
            });

            // send email
            axios.post(`${process.env.REACT_APP_API_ENDPOINT_URL}/emails/send-confirm-schedule-medical`, {
                schedule_medical_id: createNewScheduleMedicalRes.data?.data?.id,
            }, {
                auth: {
                    username: process.env.REACT_APP_BASIC_AUTH_USERNAME,
                    password: process.env.REACT_APP_BASIC_AUTH_PASSWORD
                }
            });

            if(createNewScheduleMedicalRes.data?.status === 200) {
                displayConfirmAlert(`Bạn đã đăng ký khám thành công với mã số '${scheduleNumber}'!`, () => {
                    removeCookie("makeDoctorAppointmentDatas");
                    navigate("/view_schedule");
                });
            } else {
                displayConfirmAlert(`Bạn đã đăng ký khám không thành công! Vui lòng thử lại!`);
            }    
        }
        catch(error) {
            if(error?.code) {
                toast({
                    description: `${ERROR_CODES[error?.code]} (${error?.code})`,
                    status: "error",
                    duration: 3000,
                    isClosable: true,
                    position: "bottom-right"
                });
            }
        }

        setIsSubmitting(false);
    }

    const handleProcessPayment = async() => {
        setIsSubmitting(true);
        const { company_id, scheduleNumber, patientDetail } = cookies.makeDoctorAppointmentDatas?.data;
        const payment_methods = cookies.selectedClinic?.data?.systemSettingDetail?.payment_methods;
        const ORDER_CODE = faker.number.int({max: 9999999999});
        const AMOUNT = TOTAL_SERVICE_PRICE;
        const DESCRIPTION = `Phí đặt khám ${ORDER_CODE}`;

        try
        {
            const createPaymentLinkRes = await axios.post(`${process.env.REACT_APP_WEB_SERVER_URL}/create_clinic_payment_link_payos`, {
                payOsClientId: payment_methods?.client_id,
                payOSApiKey: payment_methods?.api_key,
                payOSChecksumKey: payment_methods?.checksum_key,
                orderCode: ORDER_CODE,
                amount: AMOUNT,
                description: DESCRIPTION,
                returnUrl: `${process.env.REACT_APP_URL}/payment_response/${MAKE_DOCTOR_APPOINTMENT}/success`,
                cancelUrl: `${process.env.REACT_APP_URL}/payment_response/${MAKE_DOCTOR_APPOINTMENT}/failed`
            }, {
                auth: {
                    username: process.env.REACT_APP_BASIC_AUTH_USERNAME,
                    password: process.env.REACT_APP_BASIC_AUTH_PASSWORD
                }
            });

            if(createPaymentLinkRes?.data.status === 200) {
                // add new payment
                await axios.post(`${process.env.REACT_APP_WEB_SERVER_URL}/payments`, {
                    company_id,
                    payment_type: MAKE_DOCTOR_APPOINTMENT,
                    order_code: ORDER_CODE,
                    amount: AMOUNT,
                    description: DESCRIPTION,
                    status: PENDING_STATUS,
                    extra_data: {
                        scheduleNumber,
                        patientDetail
                    },
                }, {
                    auth: {
                        username: process.env.REACT_APP_BASIC_AUTH_USERNAME,
                        password: process.env.REACT_APP_BASIC_AUTH_PASSWORD
                    }
                });

                // open link to pay
                window.open(createPaymentLinkRes.data?.data.checkoutUrl, "_self");
            } else {
                displayConfirmAlert(`Tạo thanh toán không thành công. Bạn vui lòng thử lại hoặc liên hệ phòng khám để được hỗ trợ!`);
            }
        }
        catch(error) {
            if(error?.code) {
                toast({
                    description: `${ERROR_CODES[error?.code]} (${error?.code})`,
                    status: "error",
                    duration: 3000,
                    isClosable: true,
                    position: "bottom-right"
                });
            }
        }

        setIsSubmitting(false);
    }

    const { 
        // name, phone, yearOfBirth, social_insurance, passport, patient_code, gender, issued_by,
        // BHXH, NoBHXH, KhamTheoYeuCau, KhamDichVuChuyenKhoa, KhamSucKhoeTongQuat, KhamDichVuVip,
        scheduleNumber, scheduleDate, selectedMedicalTime, patientDetail, departmentDetail, doctorDetail, servicePriceDetail, reasonNeedDoctor
    } = cookies["makeDoctorAppointmentDatas"]?.data || {};

    const isEnable = scheduleNumber && scheduleDate && selectedMedicalTime && patientDetail && departmentDetail && doctorDetail;

    const servicePriceList = servicePriceDetail && Object.keys(servicePriceDetail).map(servicePrice => servicePriceDetail[servicePrice]["price"]);
    const TOTAL_SERVICE_PRICE = sum(servicePriceList || 0);

    if(!(cookies.selectedClinic?.data?.id)) {
        return (
            <Flex flexDirection="column">
                <Header />
                <Navbar />
                <NoEventPage text="Bạn vui lòng chọn phòng khám trước khi tiếp tục!"/>
            </Flex>
        )
    }

    return (
        <React.Fragment>
            <Box>
                <Header />
                <Navbar />

                {
                    (cookies.makeDoctorAppointmentDatas?.data && Object.keys(cookies.makeDoctorAppointmentDatas?.data).length !== 0) &&
                    
                    <Flex px={4} py={4} justifyContent="center">
                        <Box borderRadius={20} borderColor="black.700" borderWidth="1px" boxShadow="lg" bg="#ffffff" 
                            width={{ base: "100%", md: "100%", lg: "40%" }}
                            textAlign="center" justifyContent="center" px={8} py={4}
                        >
                            <Icon boxSize={8} as={MdCheckCircle} color="green"/>
                            <Text marginTop="5px" fontSize="18px" textTransform="uppercase">{t("Ticket_Information")}</Text>
                            <Text marginTop="5px" fontSize="26px" fontWeight="800" color="red">
                                {patientDetail?.name}
                            </Text>

                            <Divider marginTop="20px"/>
                            
                            <HStack my="10px">
                                <Text color="#707070">{t("Ticket_Code")}</Text>
                                <Spacer />
                                <Text fontWeight="700" color="#4caf50">{scheduleNumber}</Text>
                            </HStack>

                            <HStack my="10px">
                                <Text color="#707070">{t("Passport")}</Text>
                                <Spacer />
                                <Text fontWeight="700">{patientDetail?.passport}</Text>
                            </HStack>

                            <HStack my="10px">
                                <Text color="#707070">{t("Phone")}</Text>
                                <Spacer />
                                <Text fontWeight="700">{patientDetail?.phone}</Text>
                            </HStack>

                            <HStack my="10px">
                                <Text color="#707070">{t("Year_Of_Birth")}</Text>
                                <Spacer />
                                <Text fontWeight="700">{patientDetail?.yearOfBirth}</Text>
                            </HStack>

                            <HStack my="10px">
                                <Text color="#707070">{t("Gender")}</Text>
                                <Spacer />
                                <Text fontWeight="700">{patientDetail?.gender}</Text>
                            </HStack>

                            <Divider />

                            <HStack my="10px">
                                <Text color="#707070">{t("Schedule_Date")}</Text>
                                <Spacer />
                                { scheduleDate && <Text fontWeight="700"><FormattedDate value={scheduleDate} /></Text> }
                            </HStack>

                            <HStack my="10px">
                                <Text color="#707070">{t("Schedule_Hour")}</Text>
                                <Spacer />
                                <Text fontWeight="700">{selectedMedicalTime}</Text>
                            </HStack>

                            <HStack my="10px">
                                <Text color="#707070">{t("Department_Specialist")}</Text>
                                <Spacer />
                                { departmentDetail && <Text fontWeight="700">{departmentDetail?.name}</Text> }
                                { !departmentDetail && <Badge colorScheme='red'>Chưa chọn</Badge> }
                            </HStack>

                            <HStack my="10px">
                                <Text color="#707070">{t("Doctor")}</Text>
                                <Spacer />
                                { doctorDetail && <Text fontWeight="700">{doctorDetail?.name}</Text> }
                                { !doctorDetail && <Badge colorScheme='red'>Chưa chọn</Badge> }
                            </HStack>

                            <HStack my="10px">
                                <Text color="#707070">{t("Schedule_Reason")}</Text>
                                <Spacer />
                                <Text fontWeight="700">{reasonNeedDoctor}</Text>
                            </HStack>

                            <Divider />
                            {
                                servicePriceDetail && Object.keys(servicePriceDetail).map(servicePrice => {
                                    return (
                                        <HStack key={servicePrice} my="10px">
                                            <Text>{servicePriceDetail[servicePrice]?.name}</Text>
                                            <Spacer />
                                            {
                                                servicePriceDetail[servicePrice]?.price &&
                                                <Text fontWeight="700">
                                                    <FormattedNumber value={servicePriceDetail[servicePrice]?.price}></FormattedNumber> VND
                                                </Text>
                                            }
                                        </HStack>
                                    )
                                })
                            }

                            {
                                servicePriceDetail && Object.keys(servicePriceDetail)?.length > 0 &&
                                <HStack my="10px">
                                    <Text fontWeight="700" textTransform="uppercase">{t("Total_Money")}</Text>
                                    <Spacer />
                                    { 
                                        TOTAL_SERVICE_PRICE && 
                                        <Text color="orange.500" fontWeight="700">
                                            <FormattedNumber value={TOTAL_SERVICE_PRICE}></FormattedNumber> VND
                                        </Text> 
                                    }
                                </HStack>
                            }

                            <VStack>
                                <Text as="i" fontWeight="700">{t("Before_Confirm")}</Text>

                                <Button colorScheme='blue' width="full"
                                    isLoading={isSubmitting}
                                    loadingText="Đang xử lý"
                                    isDisabled={!isEnable}
                                    onClick={() => {
                                        displayConfirmChoiceAlert("Bạn có đồng ý xác nhận lịch đặt khám này?", () => {
                                            isProcessPaymentOnline ? handleProcessPayment() : handleSave();
                                        })
                                    }}
                                >
                                    <Icon boxSize={6} as={MdThumbUp} marginRight="8px"/> 
                                    <Text fontSize="14px" textTransform="uppercase">{t("Confirm")}</Text>
                                </Button>

                                <Button colorScheme='red' width="full"
                                    isLoading={isSubmitting}
                                    loadingText="Đang xử lý"
                                    isDisabled={!isEnable}
                                    onClick={() => {
                                        displayConfirmChoiceAlert("Bạn có đồng ý huỷ thông tin trong phiếu?", () => {
                                            removeCookie("makeDoctorAppointmentDatas");
                                        })
                                    }}
                                >
                                    <Icon boxSize={6} as={MdCancel} marginRight="8px"/> 
                                    <Text fontSize="14px">{t("Cancel")}</Text>
                                </Button>
                            </VStack>
                        </Box>
                    </Flex>
                }

                {
                    (!cookies.makeDoctorAppointmentDatas?.data || (cookies.makeDoctorAppointmentDatas?.data && Object.keys(cookies.makeDoctorAppointmentDatas?.data).length === 0)) &&
                    <VStack mt="20vh" px={4}>
                        <NoDataPage text={`Hiện chưa có thông tin về Phiếu đặt khám!`}/>
                        <Text fontSize={{ base: "16px", md: "18px", lg: "18px" }} fontWeight="700">
                            Bạn có thể bắt đầu đặt lịch khám từ
                            <Link color="teal.500" href='/' fontWeight="700" target="_blank" ml={1}>Đặt lịch khám</Link>
                        </Text>
                    </VStack>
                }
            </Box>

            {
                isSubmitting &&
                <Center>
                    <CircularProgress position="fixed" top="20vh" isIndeterminate size="200px" zIndex={9999}>
                        <CircularProgressLabel fontSize="24px" fontWeight="700" color="#2196f3">{t("Service_Price")}Đang xử lý ...</CircularProgressLabel>
                    </CircularProgress>
                </Center>
            }
        </React.Fragment>
    )
}

const mapStateToProps = (state) => {
    return {};
}

const mapDispatchToProps = (dispatch) => ({
    setNavTab:                              payload => dispatch(setNavTab(payload)),
})

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces()(ViewPatientTicket));